import * as components from './components'
import * as pages from './pages'

console.log('Plugins feature initialized!')

export { components, pages }
